module.exports = __webpack_public_path__ + "static/media/hamburger.f6056f04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/hamburger.svg
// module id = 577
// module chunks = 0